import { FC } from 'react'
import { Routes, Route } from 'react-router-dom'
import { LoginPage } from '../../pages/login'
import {
  useRedirectToLogin,
  useShowMaintenanceModal,
  useCheckAuth,
} from '../../features/users'
import { useClientUpdateNotification } from '../../features/notifications'
import { ThemeProvider } from '@mui/material/styles'
import { ToastProvider } from '../../contexts/ToastContext'
import MediLabIndexPage from './pages/index'
import MediLabLatestApp from './latest/App'
import { isLegacyUi } from './useLegacyUi'
import { useGetTheme } from '../../shared'
import { devReportRoutes } from '../../pages/devReport/routes'
import { supportRoutes } from './pages/support/routes'
import { portalRoutes } from '../../pages/portal/routes'
import { guideRoutes } from '../../pages/guide/routes'

const MediLabApp: FC = () => {
  useRedirectToLogin()
  useCheckAuth()
  const theme = useGetTheme()
  const MaintenanceModal = useShowMaintenanceModal()
  const { renderNotification } = useClientUpdateNotification()

  return (
    <>
      <ThemeProvider theme={theme}>
        <ToastProvider>
          {MaintenanceModal}
          {renderNotification()}
          <Routes>
            <Route
              path="/"
              element={
                isLegacyUi() ? <MediLabIndexPage /> : <MediLabLatestApp />
              }
            />
            <Route path="/login" element={<LoginPage />} />
            {/* MediLab系では全ルートが利用可能 */}
            {portalRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
            {devReportRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
            {supportRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
            {guideRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </Routes>
        </ToastProvider>
      </ThemeProvider>
    </>
  )
}

export default MediLabApp
